import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Header from './components/Header';
import Features from './components/Features';
import Help from './components/Help';
import Success from './components/Success';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-[#06090D]">
      <Navbar/>
      <Header/>
      <Features/>
      <Success/>
      <Help/>
      <Footer/>
    </div>
  );
}

export default App;
